// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
//import * as components from "vuetify/components";
import {
    VRow,
    VCol,
    VExpansionPanels,
    VExpansionPanel,
    VExpansionPanelText,
    VExpansionPanelTitle,
    VExpandXTransition,
    VExpandTransition,
    VCard,
    VDialog,
    VBtn,
    VImg,
    VIcon,
    VContainer,
    VSheet,
    VProgressCircular,
    VCarousel,


}
    from 'vuetify/components'
import { Intersect, Ripple } from "vuetify/directives";

const customeTheme = {
    dark: false,
    colors: {
        primary: "#0f1832",
        secondary: "#e3bb72",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        lightblue: "#14c6FF",
        yellow: "#FFCF00",
        pink: "#FF1976",
        orange: "#FF8657",
        magenta: "#C33AFC",
        darkblue: "#1E2D56",
        gray: "#909090",
        neutralgray: "#9BA6C1",
        green: "#2ED47A",
        red: "#FF5c4E",
        darkblueshade: "#308DC2",
        lightgray: "#BDBDBD",
        lightpink: "#FFCFE3",
        white: "#FFFFFF",
        black: "#000000",
        muted: "#6c757d",
    },
};

const vuetify = createVuetify({
    ssr: true,
    components: {
        VRow,
        VCol,
        VExpansionPanels,
        VExpansionPanel,
        VExpansionPanelText,
        VExpansionPanelTitle,
        VExpandXTransition,
        VExpandTransition,
        VCard,
        VDialog,
        VBtn,
        VImg,
        VIcon,
        VContainer,
        VSheet,
        VProgressCircular,
        VCarousel,


    },
    // components,
    directives: { Intersect, Ripple },
    theme: {
        defaultTheme: "customeTheme",
        themes: {
            customeTheme,
        },
    },
});

export default vuetify;
